export const RequiredIndicator = () => {
    return (
        <span className="text-danger">* </span>
    );
}